import React from 'react';
import { ShieldCheck, Activity, Zap } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const OrthopaedicsPage = () => {
  const config = {
    badge: "Orthopaedic Surgery",
    headline: "Bone & Joint",
    headlineItalic: "Surgery.",
    subtext: "Precision orthopaedic interventions for fractures, ligament injuries, hip dysplasia, and complex spinal conditions, restoring mobility and pain-free life.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Orthopaedic Surgery at Dr. Suresh Pet Care — Advanced Bone and Joint Surgery",
    stats: [
      { value: 700, suffix: '+', label: 'Ortho Surgeries' },
      { value: 96, suffix: '%', label: 'Full Recovery Rate' },
      { value: 8, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Care' },
    ],
    services: [
      {
        title: "Fracture Repair",
        icon: <ShieldCheck size={28} />,
        desc: "High-precision plating, pinning, and external fixation for fractures of all types and complexity levels.",
        specs: ["Bone Plating", "IM Pinning", "External Fixation", "Growth Plate Injuries"],
        color: "from-slate-500/10 to-primary/10"
      },
      {
        title: "Ligament Surgery",
        icon: <Activity size={28} />,
        desc: "Cruciate ligament repair (TPLO/TTA) and lateral suture stabilization for knee and joint injuries.",
        specs: ["TPLO Procedure", "TTA Surgery", "Lateral Suture", "Luxating Patella"],
        color: "from-primary/10 to-blue-500/10"
      },
      {
        title: "Spinal Surgery",
        icon: <Zap size={28} />,
        desc: "Decompressive laminectomy and hemilaminectomy for IVDD and spinal cord compression management.",
        specs: ["Laminectomy", "Hemilaminectomy", "IVDD Treatment", "Spinal Fusion"],
        color: "from-indigo-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Orthopaedic",
    sectionItalic: "Capabilities.",
    warningTitle: "Orthopaedic",
    warningItalic: "Warning Signs.",
    warningText: "Orthopaedic issues can deteriorate rapidly without expert intervention. These signs require urgent orthopaedic evaluation.",
    warnings: [
      { name: "Sudden Lameness", desc: "Non-weight-bearing on a limb after play or exercise needs radiographic evaluation.", icon: "🦴" },
      { name: "Dragging Hind Legs", desc: "Loss of hind-end function is a spinal emergency requiring immediate attention.", icon: "🚨" },
      { name: "Hip Pain", desc: "Reluctance to rise, climb stairs, or jump may indicate hip dysplasia or arthritis.", icon: "😣" },
      { name: "Swelling Around Joints", desc: "Rapid joint swelling following trauma may indicate fracture or ligament tear.", icon: "⚠️" },
    ],
    ctaBadge: "Surgical Excellence",
    ctaTitle: "The Orthopaedic",
    ctaItalic: "Expertise.",
    ctaText: "Our orthopaedic surgery team delivers precision bone and joint surgical outcomes across the full spectrum of musculoskeletal conditions in Hyderabad.",
    ctaBtn: "Book Ortho Consult",
    seoText: "Expert veterinary orthopaedic surgery in Hyderabad. Fracture repair, TPLO, and spinal surgery for dogs at Dr. Suresh Pet Care.",
    glowColor: "slate-500"
  };

  return (
    <>
      <SEO 
        title="Veterinary Orthopaedic Surgery"
        description="Advanced orthopaedic surgery for fractures, joint diseases, and spinal conditions in pets at Dr. Suresh Pet Care, Hyderabad."
        canonical="/orthopaedics"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default OrthopaedicsPage;
